export default {
	back_to_intel_retail_edge_program: "Voltar para o Programa Intel® Retail Edge",
	other_names_and_brands_could_be_claimed_as_third_party_property: "Outros nomes e marcas podem ser reinvidicados como propriedade de terceiros.",
	trademarks: "Marcas Registradas"
}
